// Module
var code = `<div ng-init="selected = { tab: 0 }" class="schema-form-tabs {{form.htmlClass}}">
  <ul class="nav nav-tabs">
    <li ng-repeat="tab in form.tabs"
        ng-disabled="form.readonly"
        ng-click="\$event.preventDefault() || (selected.tab = \$index)"
        ng-class="{active: selected.tab === \$index}">
        <a href="#">{{ tab.title }}</a>
    </li>
  </ul>

  <div class="tab-content {{form.fieldHtmlClass}}">
  </div>
</div>
`;
// Exports
module.exports = code;